// extracted by mini-css-extract-plugin
export default {"headerLabelWrapper":"HeaderTag_headerLabelWrapper__1kqp8","errorState":"HeaderTag_errorState__2EqYR","headerLabel":"HeaderTag_headerLabel__2qIIu"};